module.exports = function () {
    var $contentModules = $('#main-content').children();
    var $careersPersonaModules = $('.careers-persona-detail-body-left').first().children();

    ICF.Layout.ModuleSpacing.CollapseSpace($contentModules);
    ICF.Layout.ModuleSpacing.CollapseSpace($careersPersonaModules);
};